import 韻鏡位置 from './core/韻鏡位置';
import 音韻地位2韻鏡位置 from './core/音韻地位2韻鏡位置';
import { iter韻鏡字頭, 韻鏡位置2字頭 } from './core/韻鏡字頭';

export { 音韻地位2韻鏡位置, 韻鏡位置, iter韻鏡字頭, 韻鏡位置2字頭 };

export const VERSION = '0.1.2';
